import React, { useContext } from 'react';

import { EmptyDiv } from 'shared/functions';
import { GenericContext } from 'shared/constants';

function WidgetSkillsTaxonomy(props) {
  // @ts-expect-error
  const { settings, loadCustomComponents } = useContext(GenericContext);

  const { name, schema, onChange, value } = props;

  const [SkillsTaxonomy, setSkillsTaxonomy] = React.useState(() => EmptyDiv);
  const [selectedSkills, setSelectedSkills] = React.useState(() =>
    (value || []).reduce(
      (prev, cur) => ({
        ...prev,
        [cur.skill]: cur.proficiency,
      }),
      {},
    ),
  );

  const onChangeHandler = React.useCallback(
    (newSelectedSkills) => {
      setSelectedSkills(newSelectedSkills);
      onChange(
        Object.entries(newSelectedSkills).map(([key, value]) => ({
          proficiency: value,
          skill: key,
        })),
      );
    },
    [onChange],
  );

  React.useLayoutEffect(() => {
    loadCustomComponents(settings).then((customComponents) => {
      setSkillsTaxonomy(() => customComponents.SkillsTaxonomy);
    });
  });

  return (
    <SkillsTaxonomy
      // @ts-expect-error
      candidateCustomField={name}
      skillValueMax={schema.items?.properties?.proficiency?.maximum}
      selectedSkills={selectedSkills}
      onChange={onChangeHandler}
    />
  );
}

// eslint-disable-next-line import/no-default-export
export default WidgetSkillsTaxonomy;
